import * as React from 'react';
import { DeviceContext } from 'src/components/DeviceProvider/DeviceProvider';
import { mapUrl } from '../../../logic/main/utils';

import styles from './AnchorLayer.module.scss';

interface AnchorLayerProps {
  url: string;
  target?: string;
  shouldMapUrl?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  notIndexed?: boolean;
}

const AnchorLayer = ({
  target = '',
  url,
  shouldMapUrl = true,
  onClick,
  notIndexed,
}: AnchorLayerProps) => {
  const { deviceType, deviceOs } = React.useContext(DeviceContext);
  const mappedUrl = shouldMapUrl ? mapUrl(url, deviceType, deviceOs) : url;

  return (
    <a
      className={styles.anchor}
      data-testid="anchor-layer"
      target={target}
      rel={`${target === '_blank' ? 'noopener noreferrer ' : ''}${
        notIndexed ? 'nofollow' : ''
      }`}
      href={mappedUrl}
      onClick={e => onClick && onClick(e)}
    >
      &nbsp;
    </a>
  );
};

export default React.memo(AnchorLayer);
